import type { RutaProd } from '../../../../runtime/rutas';
export default { ruta: '/sistema/__spike/pos', documento: 'pos', acceso: 'sesion', filas: [], cita: 'PANTALLAS-PLAN.md §4.2: arnés local, no cierra 068 ni sustituye POS-1' } satisfies RutaProd;
